import {
    CarouselSlider,
    Image,
    makeStyles,
    tokens,
    typographyStyles,
} from "@fluentui/react-components";
import {
    Carousel,
    CarouselAnnouncerFunction,
    CarouselCard,
    CarouselNav,
    CarouselNavButton,
    CarouselNavContainer,
    CarouselViewport,
} from "@fluentui/react-components";
import * as React from "react";

const useClasses = makeStyles({
    bannerCard: {
        alignContent: "center",
        borderRadius: tokens.borderRadiusLarge,
        height: "100%",
        textAlign: "left",
        position: "relative",
    },
    cardContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",

        position: "absolute",
        left: "10%",
        top: "25%",
        background: tokens.colorNeutralBackground1,
        padding: "18px",
        maxWidth: "270px",
        width: "50%",
        height: "auto",
    },
    title: {
        ...typographyStyles.title1,
    },
    subtext: {
        ...typographyStyles.body1,
    },
    container: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto 1fr",
        boxShadow: tokens.shadow16,
    },
    card: {
        display: "flex",
        flexDirection: "column",

        border: `${tokens.strokeWidthThicker} solid ${tokens.colorNeutralForeground3}`,
        borderRadius: tokens.borderRadiusMedium,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,

        padding: "10px",
        minHeight: "100px",
    },
    carousel: {
        flex: 1,
        padding: "20px",
    },
    controls: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",

        border: `${tokens.strokeWidthThicker} solid ${tokens.colorNeutralForeground3}`,
        borderBottom: "none",
        borderRadius: tokens.borderRadiusMedium,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,

        padding: "10px",
    },
    field: {
        flex: 1,
        gridTemplateColumns: "minmax(100px, max-content) 1fr",
    },
    dropdown: {
        maxWidth: "max-content",
    },
});

const BannerCard: React.FC<{
    imageSrc: string;
    caption: string;
    index: number;
    total: number;
}> = (props) => {
    const { imageSrc, index, total } = props;
    const classes = useClasses();

    return (
        <CarouselCard
            className={classes.bannerCard}
            aria-label={`${index + 1} of ${total}`}
        >
            <Image fit="cover" src={imageSrc} role="presentation" />
        </CarouselCard>
    );
};

const getAnnouncement: CarouselAnnouncerFunction = (
    index: number,
    totalSlides: number,
    slideGroupList: number[][]
) => {
    return `Carousel slide ${index + 1} of ${totalSlides}`;
};

export const CarouselDisplay: React.FC<{ screenshots: any[], trailers: any[] }> = ({ screenshots, trailers }) => {
    // const classes = useClasses();

    if (screenshots.length === 0 && trailers.length === 0) {
        return null;
    }

    const items = screenshots.length > 0
        ? screenshots
        : trailers.map(trailer => ({
            url: trailer.image.url,
            caption: trailer.image.caption
        }));

    return (
        <Carousel groupSize={1} circular announcement={getAnnouncement}>
            <CarouselViewport>
                <CarouselSlider>
                    {items.map((item, index) => (
                        <BannerCard
                            key={`image-${index}`}
                            imageSrc={item.url}
                            caption={item.caption}
                            index={index}
                            total={items.length}
                        />
                    ))}
                </CarouselSlider>
            </CarouselViewport>
            <CarouselNavContainer
                layout="inline"
                next={{ "aria-label": "go to next" }}
                prev={{ "aria-label": "go to prev" }}
            >
                <CarouselNav>
                    {(index) => (
                        <CarouselNavButton
                            aria-label={`Carousel Nav Button ${index}`}
                        />
                    )}
                </CarouselNav>
            </CarouselNavContainer>
        </Carousel>
    );
};
